export type FeatureFlags = Array<{ Name: string; Enabled: boolean }>;

export const hasFeature = (featureSet: FeatureFlags, keys: string): boolean => {
    const featureKeys = Array.isArray(keys) ? keys : [keys];

    return featureKeys.every((key) => {
        return featureSet.find((item) => item.Name === key)?.Enabled;
    });
};
